export default "__VITE_ASSET__RgDw$ydw__"